<div class="table-row">
	@let
	r = getDataRow();
	@if (showDate()) {
		<div>{{row().date | date: 'HH:mm'}}</div>
	}
	<div class="font-decimaBold">
		{{row().data.note ? 'Note' : 'No Note'}}
	</div>
	<div class="ml-auto">
		{{row().data.mind.length}} Feelings
	</div>

</div>